import { Variants } from 'framer-motion';

export const CHILDREN_VARIANTS: Variants = {
  hidden: {
    y: -20,
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
  },
};
